<!--
 * @Author: Hyman Choi
 * @Date: 2021-01-21 15:24:30
 * @LastEditTime: 2022-02-10 11:44:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\role-management\index.vue
-->
<template>
	<div class="app-container">
		<!-- 角色 -->

		<!-- 顶部栏 -->
		<div class="topbar">
			<div>
				<el-input v-model="searchValue" placeholder="" size="small" prefix-icon="el-icon-search"
					class="search-input" @keyup.enter.native="search()" />
				<el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
					@click.stop="search()">
					搜索
				</el-button>
			</div>
			<el-button type="primary" size="small" icon="el-icon-plus" @click.stop="handleCreateRole()">
				新增角色
			</el-button>
		</div>

		<!-- 内容 -->
		<el-table ref="roleList" :data="roleList" :header-cell-style="{ background: '#F5F7FA' }"
			v-loading="listLoading">
			<el-table-column label="ID" prop="roleID" width="100px" align="center" />
			<el-table-column label="roleName" prop="roleName" align="center" show-overflow-tooltip />
			<el-table-column label="description" prop="description" align="center" show-overflow-tooltip />
			<el-table-column label="moduleList" prop="moduleList" align="center" show-overflow-tooltip />
			<el-table-column label="操作" width="300" align="center">
				<template slot-scope="scope">
					<el-button size="small" type="primary" @click.stop="handleEditRole(scope.row)">
						修改角色
					</el-button>
					<el-button size="small" type="danger" @click.stop="handleRemoveRole(scope.row)">
						删除
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<el-pagination v-show="totalCount > pageSize" background layout="prev, pager, next" :total="totalCount"
			:page-size="pageSize" :current-page="currentPage" @current-change="currentChange" />

		<!-- 修改角色 -->
		<el-dialog :title="dialogType === 'create' ? '添加角色' : '修改角色'" :visible.sync="dialogVisible" width="60%"
			v-loading="dialogLoading" append-to-body @close="DialogClose">

			<el-form :model="temp" label-width="80px" label-position="left" style="overflow: auto;">
				<el-form-item label="名称">
					<el-input v-model="temp.roleName" placeholder="请输入角色名称" />
				</el-form-item>
				<el-form-item label="描述">
					<el-input v-model="temp.description" :autosize="{ minRows: 2, maxRows: 4 }" type="textarea"
						placeholder="请输入角色描述" />
				</el-form-item>
				<el-form-item label="权限列表">
					<el-input placeholder="输入权限名称" v-model="permissionSearchValue" @change="filterPermission">
					</el-input>
					<el-select v-model="permissionType" clearable @change="permissionTypeChange">
						<el-option label="前端权限" :value="0" :key="0"></el-option>
						<el-option label="后端权限" :value="1" :key="1"></el-option>
					</el-select>
					<div class="el-dialog-div">
						<el-tree :filter-node-method="filterNode" ref="treeRef" :data="permissionList"
							:check-strictly="checkStrictly" :default-expanded-keys="[1]" show-checkbox
							:expand-on-click-node="false" node-key="apiPermissionID" :props="{
          children: 'children',
          label: 'permissionName',
          isLeaf: 'isLeaf',
        }">
							<template #default="{ node, data }">
								<span>
									<span>{{ data.permissionName }}</span>
									<span v-if="data.remarks"> : {{data.remarks}}</span>
								</span>
							</template>
						</el-tree>
					</div>

				</el-form-item>
			</el-form>

			<div slot="footer">
				<el-button size="small" @click="dialogVisible = false">
					取 消
				</el-button>
				<el-button size="small" type="primary" @click="dialogType === 'create' ? createRole() : editRole()">
					确 定
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getRoleList,
		roleBindPermission,
		getRoleBindPermissions,
		addRole,
		editRole,
		deleteRole,
	} from "@/api/role";
	import {
		getAllPermissionList,
		getAllPermissionListWithOption,
		updatePermissionPartially,
		removePermission,
	} from "@/api/permission";

	import {
		isVaild
	} from "@/utils/validate"

	const defaultTemp = {
		roleName: "",
		description: "",
		checkedList: [],
	};

	export default {
		data() {
			return {
				activeIndex: "0", // 当前索引
				listLoading: false, // 列表加载开关
				dialogLoading: false, // 对话框加载开关
				searchValue: "", // 搜索内容
				totalCount: 0, // 列表总数
				pageSize: 10, // 单页条数
				currentPage: 1, // 当前页码
				roleList: [],
				temp: {},
				permissionSearchValue: "",
				permissionList: [],
				permissionType: "",
				// userPermissionListForeEnd: [],
				// userPermissionListBackground: [],
				dialogType: "",
				dialogVisible: false,
				checkStrictly: false,
				// checkedList: [],
			};
		},
		created() {
			this.refreshCurrentList();
		},
		methods: {
			/**
			 * 前后端权限选项改变
			 */
			permissionTypeChange() {
				this.$refs.treeRef.filter(this.permissionSearchValue)
			},
			DialogClose(){
				this.permissionSearchValue = ""
				this.permissionType = ""
			},
			/**
			 * 刷新列表
			 */
			refreshCurrentList() {
				this.getRoleList();
			},
			/**
			 * 搜索
			 */
			search() {
				this.currentPage = 1;
				this.refreshCurrentList();
			},
			/**
			 * 重置
			 */
			reset() {
				this.searchValue = "";
				this.refreshCurrentList();
			},
			/**
			 * 翻页
			 *
			 * @param {number} currentPage 当前页码
			 */
			currentChange(currentPage) {
				this.currentPage = currentPage;
				this.refreshCurrentList();
			},
			/**
			 * @description: 获取权限列表
			 * @param {*}
			 * @return {*}
			 */
			async getPermissionList(belongToIndex) {
				this.dialogLoading = true;
				const result = await getAllPermissionListWithOption({
					background: -1, //获取全部，前后端权限在前端做筛选
					belongToIndex: belongToIndex
				});
				const array = await this.formatPermissionList(result.data);
				// this.filterText = ""
				this.$nextTick(() => {
					this.permissionList = array;
				});
				this.dialogLoading = false;
			},
			/**
			 * @description: 获取角色绑定的权限
			 * @param {*}
			 * @return {*}
			 */
			getRoleBindPermissions(roleID) {
				const params = {
					roleID,
				};

				getRoleBindPermissions(params).then((res) => {
					console.log(res.data);
					// this.checkedList = this.generateNodeKey(res.data);
					// const checkedList = this.checkedList;

					const checkedList = this.generateNodeKey(res.data);

					this.$nextTick(() => {
						this.$refs.treeRef.setCheckedKeys(checkedList);
					});
				});
			},
			/**
			 * @description: 格式化权限列表
			 * @param {*} arr
			 * @return {*}
			 */
			formatPermissionList(arr) {
				if (arr == null) {
					return []
				}
				const newArr = arr.map((item, index) => {
					const newItem = {
						apiPermissionID: item.apiPermissionID,
						permissionName: item.permissionName + (isVaild(item.remarks) ? " - " + item
							.remarks : ""),
						children: this.formatPermissionList(item.childList),
						isLeaf: item.childList == null || item.childList.length === 0,
						background: item.background
					};
					return newItem;
				});
				
				return newArr;
			},
			/**
			 * @description: 生成选中节点的node-key数组
			 * @param {*}
			 * @return {*}
			 */
			generateNodeKey(arr) {
				let res = [];
				res = arr.map((e) => e.apiPermissionID);
				return res;
			},
			/**
			 *
			 */
			filterPermission() {
				this.$refs.treeRef.filter(this.permissionSearchValue)
			},
			/**
			 *
			 */
			filterNode(value, data) {
				// if (!value) return true
				let backgroudFilter = (isVaild(this.permissionType) ? data.background ===
					this.permissionType : true);
				return (data.permissionName.includes(value) || (isVaild(data.remarks) ? data.remarks.includes(value) :
					false)) && backgroudFilter
			},
			/**
			 * 获取角色列表
			 */
			getRoleList() {
				this.listLoading = true;
				const params = {
					pageNo: this.currentPage,
					pageSize: this.pageSize,
					orderBy: "",
					orderType: "",
				};
				getRoleList(params).then((res) => {
					this.roleList = res.data.result;
					this.totalCount = res.data.totalCount
					this.listLoading = false;
				});
			},
			// /**
			//  * @description: 懒加载数据
			//  * @param {*} node
			//  * @param {*} resolve
			//  * @return {*}
			//  */
			// loadNode(node, resolve) {
			//   if (node.level === 1) {
			//     // 设置节点为叶子节点leaf = true，从而避免在叶子节点前面渲染下拉按钮
			//     const array = node.data.children.map((e) => {
			//       return {
			//         ...e,
			//         leaf: true,
			//       };
			//     });
			//     console.log("array", array);
			//     resolve(array);
			//   } else if (node.level > 1) {
			//     const data = [{ leaf: true }];
			//     resolve(data);
			//   }
			// },
			handleCreateRole() {
				this.temp = Object.assign({}, defaultTemp);
				if (this.$refs.treeRef) {
					this.$refs.treeRef.setCheckedKeys([]);
				}
				this.dialogType = "create";
				this.dialogVisible = true;
				this.getPermissionList(-1);
			},
			/**
			 * @description: 创建角色
			 * @param {*}
			 * @return {*}
			 */
			async createRole() {

				const temp = this.temp;
				const params1 = {
					roleName: temp.roleName,
					description: temp.description,
				};
				const res1 = await addRole(params1);
				if (res1.code === 200) {
					this.$message({
						type: "success",
						message: res1.message,
					});
				} else {
					this.$message({
						type: "error",
						message: "添加失败" + res1.message,
					});
					return;
				}
				const checkedNodes = this.$refs.treeRef.getCheckedNodes(true);
				// 将选择节点的ID存入数组
				const permissionIDArray = checkedNodes.map((e) => e.apiPermissionID);
				const permissionParams = {
					permissionIDArray,
					roleID: res1.data,
				};
				await roleBindPermission(permissionParams)
				this.refreshCurrentList();
				this.dialogVisible = false;
			},
			handleEditRole(row) {
				Promise.all([
					this.getPermissionList(-1),
					this.getRoleBindPermissions(row.roleID),
				]);

				this.dialogType = "edit";
				this.dialogVisible = true;

				this.temp = this._.cloneDeep(row);
				console.log("temp", this.temp);
			},
			/**
			 * @description: 修改角色
			 * @param {*}
			 * @return {*}
			 */
			// async editRole() {
			//   const checkedNodes = this.$refs.treeRef.getCheckedNodes(true);
			//   // 将选择节点的ID存入数组
			//   const permissionIDArray = checkedNodes.map((e) => e.apiPermissionID);
			//   const { roleID } = this.temp;
			//   const params1 = {
			//     permissionIDArray,
			//     roleID,
			//   };
			//   const res1 = await roleBindPermission(params1);
			//   const temp = this.temp;
			//   const params2 = {
			//     roleID: temp.roleID,
			//     roleName: temp.roleName,
			//     description: temp.description,
			//   };
			//   const res2 = await editRole(params2);
			//   this.$message({
			//     type: "success",
			//     message: "修改成功",
			//   });
			//   this.dialogVisible = false;
			//   // this.checkedList = [];
			//   if (this.$refs.treeRef) {
			//     this.$refs.treeRef.setCheckedNodes([]);
			//   }
			//   this.refreshCurrentList();
			// },
			async editRole() {
				this.dialogLoading = true;
				const checkedNodes = this.$refs.treeRef.getCheckedNodes(true);
				// 将选择节点的ID存入数组
				const permissionIDArray = checkedNodes.map((e) => e.apiPermissionID);
				const temp = this.temp;
				const params1 = {
					permissionIDArray,
					roleID: temp.roleID,
				};
				const params2 = {
					roleID: temp.roleID,
					roleName: temp.roleName,
					description: temp.description,
				};

				const res = await Promise.all([
					roleBindPermission(params1),
					editRole(params2),
				]);
				// if (
				//   // 判断请求结果是否正常
				//   res.every((e) => {
				//     console.log(e.code);
				//     e.code === 201;
				//   })
				// ) {
				//   this.$message({
				//     type: "success",
				//     message: "修改成功",
				//   });
				// } else {
				//   this.$message({
				//     type: "error",
				//     message: "修改失败",
				//   });
				// }
				// res.every遍历bug，所以用这种方式
				if (res[0].code === 200 && res[1].code) {
					this.$message({
						type: "success",
						message: "修改成功",
					});
				} else {
					this.$message({
						type: "error",
						message: "修改失败",
					});
				}
				this.dialogLoading = false;
				this.dialogVisible = false;
				// this.checkedList = [];
				if (this.$refs.treeRef) {
					this.$refs.treeRef.setCheckedNodes([]);
				}
				this.refreshCurrentList();
			},

			/**
			 * @description: 删除角色
			 * @param {*} row
			 * @return {*}
			 */
			handleRemoveRole(row) {
				this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						const roleID = row.roleID;
						const params = {
							roleID,
						};
						deleteRole(params).then((res) => {
							if (res.code === 200) {
								this.$message({
									type: "success",
									message: res.message,
								});
							} else {
								this.$message({
									type: "warning",
									message: "删除失败！",
								});
							}
							this.refreshCurrentList();
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
						this.refreshCurrentList();
					});
			},
		},
	};
</script>

<style scoped lang="scss">
	.el-dialog-div {
		height: 60vh;
		overflow: auto;
	}
</style>
